import React from 'react';
import { displayName } from '../../../../App';
import MainGuidanceLayout from '../../../components/Layout/Main';
import Content from '../../../components/Pages/Statements/Mortgage';

function MortgageStatements() {
  document.title = `${displayName}: Mortgage Statements`;

  return (
    <MainGuidanceLayout>
      <Content />
    </MainGuidanceLayout>
  );
}

export default MortgageStatements;
